// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: audit.proto

export const protobufPackage = 'compasspb';

/** AuditStatus mirrors compasscorepb.AuditStatus. */
export enum AuditStatus {
  AUDIT_STATUS_UNSPECIFIED = 0,
  AUDIT_STATUS_IN_PROGRESS = 1,
  AUDIT_STATUS_COMPLETED = 2,
  AUDIT_STATUS_FAILED = 3,
  AUDIT_STATUS_SKIPPED = 4,
  AUDIT_STATUS_CANCELLED = 5,
}

/** AuditType mirrors compasscorepb.AuditType. */
export enum AuditType {
  AUDIT_TYPE_UNSPECIFIED = 0,
  AUDIT_TYPE_AI = 1,
  AUDIT_TYPE_HUMAN = 2,
}

/** Audit mirrors compasscorepb.CoreAudit. */
export interface Audit {
  id?: string | undefined;
  case_id?: string | undefined;
  prompt_version?: string | undefined;
  rules_version?: string | undefined;
  normalizer_version?: string | undefined;
  recommendation?: string | undefined;
  model?: string | undefined;
  overall_confidence?: number | undefined;
  program_id?: string | undefined;
  payer_name?: string | undefined;
  analyzed_at?: string | undefined;
  corrections?: AuditCorrection[] | undefined;
  conditional_checks?: AuditConditionalCheck[] | undefined;
  handoff_actions?: AuditHandoffAction[] | undefined;
  decision_rationale?: string | undefined;
  applied_conditionals?: string[] | undefined;
  usage?: AuditUsage | undefined;
  created_at?: string | undefined;
  updated_at?: string | undefined;
  status?: AuditStatus | undefined;
  failure_reason?: string | undefined;
  started_at?: string | undefined;
  finished_at?: string | undefined;
  /**
   * Authorship. UNSPECIFIED on a stored row is treated as AI by readers
   * for back-compat with rows pre-dating this field.
   */
  type?: AuditType | undefined;
  /**
   * auditor_user_id is the hex user ID of the human auditor who performed the
   * session (BI-1246). Set only for AUDIT_TYPE_HUMAN rows; empty for AI audits.
   */
  auditor_user_id?: string | undefined;
  /**
   * output_snapshot is the case's output_data.data as the auditor read it —
   * the "before" side of every per-field diff, captured once and never
   * rewritten. Read-only over HTTP: there is no matching field on
   * UpdateAuditRequest, so a human-audit session cannot disturb its own
   * baseline. Absent on rows that predate the field, where the dashboard
   * falls back to inferring the before-values.
   */
  output_snapshot?: { [key: string]: any } | undefined;
}

export interface AuditCorrection {
  field?: string | undefined;
  action?: string | undefined;
  /** the value to land at; null/absent means remove */
  corrected_value?: any | undefined;
  evidence?: string | undefined;
  rule_refs?: string[] | undefined;
  reasoning?: string | undefined;
  /**
   * original_value is the field's value before the human auditor's first edit
   * (BI-1246); the UI diffs original_value → corrected_value. Empty for AI audits.
   */
  original_value?: any | undefined;
}

export interface AuditConditionalCheck {
  rule_id?: string | undefined;
  status?: string | undefined;
  note?: string | undefined;
}

export interface AuditHandoffAction {
  field?: string | undefined;
  note?: string | undefined;
}

export interface AuditUsage {
  main?: AuditUsageEntry | undefined;
  haiku?: AuditUsageEntry | undefined;
  total_cost_usd?: number | undefined;
}

export interface AuditUsageEntry {
  cost_usd?: number | undefined;
  input_tokens?: number | undefined;
  output_tokens?: number | undefined;
  cache_read_input_tokens?: number | undefined;
  cache_creation_input_tokens?: number | undefined;
  num_turns?: number | undefined;
  duration_ms?: number | undefined;
  calls?: number | undefined;
}

export interface AuditFeedback {
  id?: string | undefined;
  case_id?: string | undefined;
  scope?: string | undefined;
  field?: string | undefined;
  verdict?: string | undefined;
  bucket?: string | undefined;
  feedback?: string | undefined;
  ai_value?: string | undefined;
  llm_value?: string | undefined;
  human_value?: string | undefined;
  prompt_version?: string | undefined;
  rules_version?: string | undefined;
  normalizer_version?: string | undefined;
  model?: string | undefined;
  recommendation?: string | undefined;
  analyzed_at?: string | undefined;
  created_at?: string | undefined;
}

export interface AuditCorrectionList {
  values?: AuditCorrection[] | undefined;
}

export interface AuditConditionalCheckList {
  values?: AuditConditionalCheck[] | undefined;
}

export interface AuditHandoffActionList {
  values?: AuditHandoffAction[] | undefined;
}

export interface AuditAppliedConditionalsList {
  values?: string[] | undefined;
}

export interface ListAuditsRequest {
  /** Scope (URL path). */
  organization_id?: string | undefined;
  program_id?: string | undefined;
  /** Optional filters. */
  case_id?: string | undefined;
  recommendation?: string | undefined;
  payer_name?: string | undefined;
  /** Pagination. */
  limit?: number | undefined;
  /** cursor */
  start_after_id?: string | undefined;
}

export interface ListAuditsResponse {
  audits?: Audit[] | undefined;
  next_cursor?: string | undefined;
}

export interface GetAuditRequest {
  /** Scope (URL path). */
  organization_id?: string | undefined;
  program_id?: string | undefined;
  /** required (24-hex ObjectID) */
  audit_id?: string | undefined;
}

export interface GetAuditResponse {
  audit?: Audit | undefined;
}

/**
 * UpdateAuditRequest carries a partial update for an audit row.
 * program_id is intentionally not present as a body field — it is a
 * bookkeeping field set at audit-creation time and should not be mutated
 * over the HTTP surface; the URL's program_id is used for permission
 * scope only.
 */
export interface UpdateAuditRequest {
  /** Scope (URL path). */
  organization_id?: string | undefined;
  program_id?: string | undefined;
  /** required (24-hex ObjectID) */
  audit_id?: string | undefined;
  recommendation?: string | undefined;
  model?: string | undefined;
  overall_confidence?: number | undefined;
  payer_name?: string | undefined;
  analyzed_at?: string | undefined;
  corrections?: AuditCorrectionList | undefined;
  conditional_checks?: AuditConditionalCheckList | undefined;
  handoff_actions?: AuditHandoffActionList | undefined;
  decision_rationale?: string | undefined;
  applied_conditionals?: AuditAppliedConditionalsList | undefined;
  usage?: AuditUsage | undefined;
  status?: AuditStatus | undefined;
  failure_reason?: string | undefined;
  started_at?: string | undefined;
  finished_at?: string | undefined;
}

export interface UpdateAuditResponse {
  audit?: Audit | undefined;
}

/**
 * CreateAuditFeedbackRequest carries a human ground-truth annotation
 * against the audit run identified by audit_id (URL). The server stamps
 * the audit's case_id + version triple + model + recommendation +
 * analyzed_at onto the new row — clients only send the annotation
 * content.
 */
export interface CreateAuditFeedbackRequest {
  /** Scope (URL path). */
  organization_id?: string | undefined;
  program_id?: string | undefined;
  /** required (24-hex ObjectID) */
  audit_id?: string | undefined;
  /** Annotation content. */
  scope?: string | undefined;
  /** short field name (empty for case-level) */
  field?: string | undefined;
  /** "AI_CORRECT" | "HUMAN_CORRECT" | "" */
  verdict?: string | undefined;
  bucket?: string | undefined;
  /** free-text reviewer note */
  feedback?: string | undefined;
  /** Value snapshot. */
  ai_value?: string | undefined;
  llm_value?: string | undefined;
  human_value?: string | undefined;
}

export interface CreateAuditFeedbackResponse {
  feedback?: AuditFeedback | undefined;
}

export interface ListAuditFeedbackRequest {
  /** Scope (URL path). */
  organization_id?: string | undefined;
  program_id?: string | undefined;
  /** Optional filters. */
  case_id?: string | undefined;
  scope?: string | undefined;
  verdict?: string | undefined;
  /** Pagination. */
  limit?: number | undefined;
  /** cursor */
  start_after_id?: string | undefined;
}

export interface ListAuditFeedbackResponse {
  feedback?: AuditFeedback[] | undefined;
  next_cursor?: string | undefined;
}

export interface ListCaseAuditsRequest {
  /** Scope (URL path). */
  organization_id?: string | undefined;
  program_id?: string | undefined;
  /** required (24-hex case record ID) */
  case_id?: string | undefined;
  /** Optional filters. */
  recommendation?: string | undefined;
  payer_name?: string | undefined;
  /** Pagination. */
  limit?: number | undefined;
  /** cursor */
  start_after_id?: string | undefined;
}

export interface ListCaseAuditsResponse {
  audits?: Audit[] | undefined;
  next_cursor?: string | undefined;
}

export interface GetCaseAuditRequest {
  /** Scope (URL path). */
  organization_id?: string | undefined;
  program_id?: string | undefined;
  /** required (24-hex case record ID the audit belongs to) */
  case_id?: string | undefined;
  /** required (24-hex ObjectID) */
  audit_id?: string | undefined;
}

export interface GetCaseAuditResponse {
  audit?: Audit | undefined;
}

/**
 * UpdateCaseAuditRequest carries the same partial update as
 * UpdateAuditRequest (same field numbers) plus the path case_id.
 */
export interface UpdateCaseAuditRequest {
  /** Scope (URL path). */
  organization_id?: string | undefined;
  program_id?: string | undefined;
  /** required (24-hex ObjectID) */
  audit_id?: string | undefined;
  /** required (24-hex case record ID the audit belongs to) */
  case_id?: string | undefined;
  recommendation?: string | undefined;
  model?: string | undefined;
  overall_confidence?: number | undefined;
  payer_name?: string | undefined;
  analyzed_at?: string | undefined;
  corrections?: AuditCorrectionList | undefined;
  conditional_checks?: AuditConditionalCheckList | undefined;
  handoff_actions?: AuditHandoffActionList | undefined;
  decision_rationale?: string | undefined;
  applied_conditionals?: AuditAppliedConditionalsList | undefined;
  usage?: AuditUsage | undefined;
  status?: AuditStatus | undefined;
  failure_reason?: string | undefined;
  started_at?: string | undefined;
  finished_at?: string | undefined;
}

export interface UpdateCaseAuditResponse {
  audit?: Audit | undefined;
}

/**
 * CreateCaseAuditFeedbackRequest carries the same annotation as
 * CreateAuditFeedbackRequest (same field numbers) plus the path case_id.
 */
export interface CreateCaseAuditFeedbackRequest {
  /** Scope (URL path). */
  organization_id?: string | undefined;
  program_id?: string | undefined;
  /** required (24-hex ObjectID) */
  audit_id?: string | undefined;
  /** required (24-hex case record ID the audit belongs to) */
  case_id?: string | undefined;
  /** Annotation content. */
  scope?: string | undefined;
  /** short field name (empty for case-level) */
  field?: string | undefined;
  /** "AI_CORRECT" | "HUMAN_CORRECT" | "" */
  verdict?: string | undefined;
  bucket?: string | undefined;
  /** free-text reviewer note */
  feedback?: string | undefined;
  /** Value snapshot. */
  ai_value?: string | undefined;
  llm_value?: string | undefined;
  human_value?: string | undefined;
}

export interface CreateCaseAuditFeedbackResponse {
  feedback?: AuditFeedback | undefined;
}

export interface ListCaseAuditFeedbackRequest {
  /** Scope (URL path). */
  organization_id?: string | undefined;
  program_id?: string | undefined;
  /** required (24-hex case record ID) */
  case_id?: string | undefined;
  /** Optional filters. */
  scope?: string | undefined;
  verdict?: string | undefined;
  /** Pagination. */
  limit?: number | undefined;
  /** cursor */
  start_after_id?: string | undefined;
}

export interface ListCaseAuditFeedbackResponse {
  feedback?: AuditFeedback[] | undefined;
  next_cursor?: string | undefined;
}

/**
 * AuditService provides HTTP API for browsing and updating LLM-audit runs.
 * The first five endpoints are program-scoped (case_record at program scope)
 * and DEPRECATED: they stay unchanged for existing frontends and pods, and new
 * callers use the Case* endpoints instead. The Case* endpoints are scoped to
 * one case record and also accept case_record at assigned scope. All require
 * an authenticated user.
 * This is the HTTP-facing service; for internal gRPC see CoreAuditService in
 * compasscorepb (called by themis-server during the audit run).
 */
export interface AuditService {
  /**
   * ListAudits returns audits ordered by analyzed_at DESC with cursor-based
   * pagination. All filters are optional; passing case_id returns the run
   * history for that case.
   *
   * Deprecated: for one case use ListCaseAudits (case-scoped,
   * .../caserecords/{case_id}/...). Program-wide listing without case_id has no
   * case-scoped replacement yet. Kept unchanged for existing callers.
   *
   * @deprecated
   */
  listAudits(request: ListAuditsRequest): Promise<ListAuditsResponse>;
  /**
   * GetAudit returns a single audit row by audit_id.
   *
   * Deprecated: use GetCaseAudit (case-scoped, .../caserecords/{case_id}/...).
   * Kept unchanged for existing callers; scheduled for removal.
   *
   * @deprecated
   */
  getAudit(request: GetAuditRequest): Promise<GetAuditResponse>;
  /**
   * UpdateAudit applies a partial update to an audit row identified by
   * audit_id. Only fields explicitly set in the request are written; the
   * cache-key fields (case_id and the three version strings) are immutable.
   *
   * Deprecated: use UpdateCaseAudit (case-scoped, .../caserecords/{case_id}/...).
   * Kept unchanged for existing callers; scheduled for removal.
   *
   * @deprecated
   */
  updateAudit(request: UpdateAuditRequest): Promise<UpdateAuditResponse>;
  /**
   * CreateAuditFeedback records a human ground-truth annotation against a
   * specific audit run. The audit_id in the URL identifies the run; the
   * server stamps the audit's case_id, version triple, model, and
   * recommendation onto the new feedback row.
   *
   * Deprecated: use CreateCaseAuditFeedback (case-scoped, .../caserecords/{case_id}/...).
   * Kept unchanged for existing callers; scheduled for removal.
   *
   * @deprecated
   */
  createAuditFeedback(request: CreateAuditFeedbackRequest): Promise<CreateAuditFeedbackResponse>;
  /**
   * ListAuditFeedback returns human ground-truth annotations for a case
   * (or all cases when case_id is omitted).
   *
   * Deprecated: for one case use ListCaseAuditFeedback (case-scoped,
   * .../caserecords/{case_id}/...). Program-wide listing without case_id has no
   * case-scoped replacement yet. Kept unchanged for existing callers.
   *
   * @deprecated
   */
  listAuditFeedback(request: ListAuditFeedbackRequest): Promise<ListAuditFeedbackResponse>;
  /**
   * ListCaseAudits returns the audit-run history of one case, ordered by
   * analyzed_at DESC with cursor-based pagination.
   */
  listCaseAudits(request: ListCaseAuditsRequest): Promise<ListCaseAuditsResponse>;
  /** GetCaseAudit returns a single audit row of the case in the path. */
  getCaseAudit(request: GetCaseAuditRequest): Promise<GetCaseAuditResponse>;
  /**
   * UpdateCaseAudit applies a partial update to an audit row of the case in
   * the path, with the same semantics as UpdateAudit.
   */
  updateCaseAudit(request: UpdateCaseAuditRequest): Promise<UpdateCaseAuditResponse>;
  /**
   * CreateCaseAuditFeedback records a human ground-truth annotation against
   * an audit run of the case in the path, with the same semantics as
   * CreateAuditFeedback.
   */
  createCaseAuditFeedback(
    request: CreateCaseAuditFeedbackRequest,
  ): Promise<CreateCaseAuditFeedbackResponse>;
  /**
   * ListCaseAuditFeedback returns human ground-truth annotations for the case
   * in the path.
   */
  listCaseAuditFeedback(
    request: ListCaseAuditFeedbackRequest,
  ): Promise<ListCaseAuditFeedbackResponse>;
}
